
import {
  ADD_PROVIDER_PRACTICE,
  ADD_SERVICE,
  CHANGE_PRACTICE_AVAILABILITY,
  CHANGE_SERVICE_AVAILABILITY,
  DELETE_PROVIDER_PRACTICE,
  DELETE_SERVICE,
  GET_NOMENCLATURES,
  GET_PRACTICES,
  GET_PROVIDER_SERVICES_BY_NOMENCLATURA,
  GET_SERVICES,
  REMOVE_PROVIDED_SERVICE_BY_ID,
  REMOVE_PROVIDER_PRACTICE_BY_ID,
  UPDATE_PROVIDED_SERVICE_AVAILABILITY,
  UPDATE_PROVIDER_PRACTICE_AVAILABILITY
} from "../actions/providedServices";

const INITIAL_STATE = {
  getServices: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  changeServiceAvailability: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  deleteService: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  addService: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  providerServicesByNomenclature: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  deleteProviderPractice: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  practices: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  subnomenclatures: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  addProviderPractice: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  changePracticeAvailability: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  }
};


const providedServices = (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case `${GET_SERVICES}_PENDING`:
      return {
        ...state,
        getServices: {
          ...state.getServices,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_SERVICES}_REJECTED`:
      return {
        ...state,
        getServices: {
          ...state.getServices,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_SERVICES}_FULFILLED`: {
      return {
        ...state,
        getServices: {
          ...state.getServices,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${CHANGE_SERVICE_AVAILABILITY}_PENDING`:
      return {
        ...state,
        changeServiceAvailability: {
          ...state.changeServiceAvailability,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${CHANGE_SERVICE_AVAILABILITY}_REJECTED`:
      return {
        ...state,
        changeServiceAvailability: {
          ...state.changeServiceAvailability,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${CHANGE_SERVICE_AVAILABILITY}_FULFILLED`: {
      return {
        ...state,
        changeServiceAvailability: {
          ...state.changeServiceAvailability,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${DELETE_SERVICE}_PENDING`:
      return {
        ...state,
        deleteService: {
          ...state.deleteService,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${DELETE_SERVICE}_REJECTED`:
      return {
        ...state,
        deleteService: {
          ...state.deleteService,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${DELETE_SERVICE}_FULFILLED`: {
      return {
        ...state,
        deleteService: {
          ...state.deleteService,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${ADD_SERVICE}_PENDING`:
      return {
        ...state,
        addService: {
          ...state.addService,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${ADD_SERVICE}_REJECTED`:
      return {
        ...state,
        addService: {
          ...state.addService,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${ADD_SERVICE}_FULFILLED`: {
      return {
        ...state,
        addService: {
          ...state.addService,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${UPDATE_PROVIDED_SERVICE_AVAILABILITY}`: {
      return {
        ...state,
        getServices: {
          ...state.getServices,
          data: state.getServices.data.map(p => {
            if (p.prestacion === action.payload.prestacion && p.subnomenclador === action.payload.subnomenclador) {
              return { ...p, habilitada: action.payload.enabled }
            } else {
              return p;
            }
          })
        }
      }
    }
    case `${REMOVE_PROVIDED_SERVICE_BY_ID}`: {
      return {
        ...state,
        getServices: {
          ...state.getServices,
          data: state.getServices.data.filter(service => {
            return service.prestacion !== action.payload.prestacion || service.subnomenclador !== action.payload.subnomenclador
          })
        }
      }
    }
    case `${CHANGE_PRACTICE_AVAILABILITY}_PENDING`:
      return {
        ...state,
        changePracticeAvailability: {
          ...state.changePracticeAvailability,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${CHANGE_PRACTICE_AVAILABILITY}_REJECTED`:
      return {
        ...state,
        changePracticeAvailability: {
          ...state.changePracticeAvailability,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${CHANGE_PRACTICE_AVAILABILITY}_FULFILLED`: {
      return {
        ...state,
        changePracticeAvailability: {
          ...state.changePracticeAvailability,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${ADD_PROVIDER_PRACTICE}_PENDING`:
      return {
        ...state,
        addProviderPractice: {
          ...state.addProviderPractice,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${ADD_PROVIDER_PRACTICE}_REJECTED`:
      return {
        ...state,
        addProviderPractice: {
          ...state.addProviderPractice,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${ADD_PROVIDER_PRACTICE}_FULFILLED`: {
      return {
        ...state,
        addProviderPractice: {
          ...state.addProviderPractice,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${GET_NOMENCLATURES}_PENDING`:
      return {
        ...state,
        subnomenclatures: {
          ...state.subnomenclatures,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_NOMENCLATURES}_REJECTED`:
      return {
        ...state,
        subnomenclatures: {
          ...state.subnomenclatures,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_NOMENCLATURES}_FULFILLED`: {
      return {
        ...state,
        subnomenclatures: {
          ...state.subnomenclatures,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${GET_PRACTICES}_PENDING`:
      return {
        ...state,
        practices: {
          ...state.practices,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_PRACTICES}_REJECTED`:
      return {
        ...state,
        practices: {
          ...state.practices,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_PRACTICES}_FULFILLED`: {
      return {
        ...state,
        practices: {
          ...state.practices,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${GET_PROVIDER_SERVICES_BY_NOMENCLATURA}_PENDING`:
      return {
        ...state,
        providerServicesByNomenclature: {
          ...state.providerServicesByNomenclature,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_PROVIDER_SERVICES_BY_NOMENCLATURA}_REJECTED`:
      return {
        ...state,
        providerServicesByNomenclature: {
          ...state.providerServicesByNomenclature,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_PROVIDER_SERVICES_BY_NOMENCLATURA}_FULFILLED`: {
      return {
        ...state,
        providerServicesByNomenclature: {
          ...state.providerServicesByNomenclature,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${DELETE_PROVIDER_PRACTICE}_PENDING`:
      return {
        ...state,
        deleteProviderPractice: {
          ...state.deleteProviderPractice,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${DELETE_PROVIDER_PRACTICE}_REJECTED`:
      return {
        ...state,
        deleteProviderPractice: {
          ...state.deleteProviderPractice,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${DELETE_PROVIDER_PRACTICE}_FULFILLED`: {
      return {
        ...state,
        deleteProviderPractice: {
          ...state.deleteProviderPractice,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${UPDATE_PROVIDER_PRACTICE_AVAILABILITY}`: {
      return {
        ...state,
        practices: {
          ...state.practices,
          data: state.practices.data.map(p => {
            if (p.id === action.payload.practiceId) {
              return { ...p, habilitada: action.payload.enabled }
            } else {
              return p;
            }
          })
        }
      }
    }
    case `${REMOVE_PROVIDER_PRACTICE_BY_ID}`: {
      return {
        ...state,
        practices: {
          ...state.practices,
          data: state.practices.data.filter(service => service.id !== action.payload)
        }
      }
    }
    default:
      return state;
  }
}

export default providedServices;